import { Maybe, QuizPerformanceAttempt } from '@/types/schema';

import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';

const EMPTY_ARRAY: never[] = [];

const getQuizModifiedAttempts = (
  performance?: Maybe<Omit<QuizDetailsPerformanceFragment, 'isAvailable'>>,
) => {
  const attemptsHistory = [...(performance?.attempts || EMPTY_ARRAY)]
    .reverse()
    .map((attempt) => ({ ...attempt, attemptedAt: attempt.attemptedAt || attempt.updatedAt }));
  if (!performance || !performance.isSubmitted) {
    return attemptsHistory;
  }

  const {
    attemptId,
    score,
    status,
    timeSpent,
    isSubmitted,
    updatedAt,
    result,
    scorePercentage,
    correctAnswersCount,
    maxScore,
    completedAt,
  } = performance;
  const latestAttempt: QuizPerformanceAttempt = {
    attemptId,
    score,
    status,
    timeSpent,
    isSubmitted,
    updatedAt,
    result,
    scorePercentage,
    correctAnswersCount,
    maxScore,
    attemptedAt: completedAt,
  };

  return [latestAttempt, ...attemptsHistory];
};

export default getQuizModifiedAttempts;
